<template>
<div>
<ContentOverlay></ContentOverlay>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">
<ContentHeader :title="$store.state.languages.lang_phrases.soru_listeleri"  url="CreateProject" :show_button="false" icon="plus" buttontype="primary" label="Yeni Ekle"></ContentHeader>

<div class="content_card_content">


<!--
<ContentTable :data="data" :columns="columns" routename="Questionlist" deleteobjectname="questionlist" @dataDeleted="getData"></ContentTable>
-->
<DataTable 
:value="items" 
:paginator="true" 
class="p-datatable-suppliers" 
:rows="10"
dataKey="id" 
:rowHover="true"  
filterDisplay="menu" 
:loading="loading"
:rowsPerPageOptions="[5,10,25,50,100]"
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
responsiveLayout="scroll"
>

 <Column   :header="$store.state.languages.lang_phrases.soru_listesi" >
<template #body="slotProps">
<p>{{ slotProps.data.questionlist.name}}</p>
</template>
</Column>

<Column    >
<template #body="slotProps">
  <Button type="button" class="p-button-primary p-button-outlined p-button-sm ml-2"  icon="pi pi-eye" @click="openPreview(slotProps.data.questionlist.id)" />
</template>
</Column>





</DataTable>

</div>





</div>







</div>
</template>

<script>
export default {

  name: 'QuestionlistPreviews',

  data () {
    return {
    	items:[],
      loading:true,
    }
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
  	{
  		//this.data = await this.generalApiGet("questionlists") 
      console.log(this.$store.state.auth)
      this.loading = true
      this.items = await this.generalApiGetWithoutLoader("auditor/questionlists/"+this.$store.state.auth.user.id)
      console.log(this.items);
      this.loading = false

  	},
    openPreview(id)
    {
      window.open(process.env.VUE_APP_APP_ROOT+"/"+this.$store.state.auth.user.uuid+"/questionlist_preview/"+id, '_blank').focus();
    },
  	
  }
};
</script>

<style lang="css" scoped>
</style>